import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";

const money = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);
const series = [["dizimo", "Dízimo", "#1e40af"], ["oferta", "Oferta", "#60a5fa"], ["voto", "Voto", "#e8b990"]];

const AXIS_TICK = { fontSize: 10 };
const Y_TICK = { fontSize: 11 };
const CURSOR = { fill: "#e6eefb" };
const LEGEND_STYLE = { fontSize: 12 };
const BAR_RADIUS = [4, 4, 0, 0];
const yFormat = v => (Math.abs(v) >= 1000 ? `R$${Number((v / 1000).toFixed(1))}k` : `R$${v}`);

export const CategoryChart = ({ data }) => {
  const rows = (data || []).filter(r => r.dizimo || r.oferta || r.voto);
  const totals = series.map(([k, label, color]) => ({ label, color, value: rows.reduce((s, r) => s + r[k], 0) }));
  return <section className="panel category-panel" data-testid="category-chart">
    <div className="panel-heading"><div><p className="eyebrow">CATEGORIAS</p><h2>Dízimo, oferta e voto por igreja</h2></div>
      <div className="category-totals">{totals.map(t => <span key={t.label} data-testid={`category-total-${t.label.toLowerCase()}`}><i className="dot" style={{ background: t.color }} /> {t.label} <b>{money(t.value)}</b></span>)}</div></div>
    <div className="chart">{rows.length ? <ResponsiveContainer width="100%" height="100%"><BarChart data={rows}>
      <XAxis dataKey="church" tick={AXIS_TICK} interval={0} angle={-18} textAnchor="end" height={55} />
      <YAxis tick={Y_TICK} tickFormatter={yFormat} />
      <Tooltip cursor={CURSOR} formatter={money} /><Legend wrapperStyle={LEGEND_STYLE} />
      {series.map(([k, label, color]) => <Bar key={k} dataKey={k} name={label} fill={color} radius={BAR_RADIUS} />)}
    </BarChart></ResponsiveContainer> : <p className="empty">Nenhuma entrada por categoria no período.</p>}</div>
  </section>;
};
